import VehicleBlockSeparatorInfernal from "./VehicleBlockSeparatorInfernal";

export default VehicleBlockSeparatorInfernal;
export { VehicleBlockSeparatorInfernal };
